import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function PaperPlus({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <PaperPlus.Outline {...props} />
  ) : (
    <PaperPlus.Solid {...props} />
  );
}

PaperPlus.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

PaperPlus.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/* Secondary (lighter) paths - document background */}
        <path
          d="M18.8088 9.021C18.3573 9.021 17.7592 9.011 17.0146 9.011C15.1987 9.011 13.7055 7.508 13.7055 5.675V2.459C13.7055 2.206 13.5026 2 13.253 2H7.96363C5.49517 2 3.5 4.026 3.5 6.509V17.284C3.5 19.889 5.59022 22 8.16958 22H16.0453C18.5058 22 20.5 19.987 20.5 17.502V9.471C20.5 9.217 20.298 9.012 20.0465 9.013C19.6247 9.016 19.1168 9.021 18.8088 9.021Z"
          className="icon-secondary"
        />
        <path
          d="M16.0837 2.56737C15.7847 2.25637 15.2627 2.47037 15.2627 2.90137V5.53837C15.2627 6.64437 16.1737 7.55437 17.2787 7.55437C17.9767 7.56237 18.9447 7.56437 19.7667 7.56237C20.1877 7.56137 20.4017 7.05837 20.1097 6.75437C19.0547 5.65737 17.1657 3.69137 16.0837 2.56737Z"
          className="icon-secondary"
        />
        {/* Primary (darker) path - plus sign */}
        <path
          d="M14.3677 12.2357H12.6397V10.5087C12.6397 10.0977 12.3067 9.76367 11.8957 9.76367C11.4847 9.76367 11.1507 10.0977 11.1507 10.5087V12.2357H9.42369C9.01269 12.2357 8.67969 12.5697 8.67969 12.9807C8.67969 13.3917 9.01269 13.7257 9.42369 13.7257H11.1507V15.4517C11.1507 15.8627 11.4847 16.1967 11.8957 16.1967C12.3067 16.1967 12.6397 15.8627 12.6397 15.4517V13.7257H14.3677C14.7787 13.7257 15.1127 13.3917 15.1127 12.9807C15.1127 12.5697 14.7787 12.2357 14.3677 12.2357Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
